<template>
    <div class="search-filter">
        <div class="container full-width top">
            <div class="row">
                <!-- <div class="column" style="color: white; text-align: center; position: relative;" v-for="(item, index) in searchItems" v-bind:key="item.title">
                    <button class="dropdown-button" type="button" @click="resetChoices(index)">{{ item.value.title }}</button>
                </div> -->
                <input type="text" default="Search" v-model="filter" placeholder="Search">
                <!-- <div class="column" style="text-align: center;">
                    <button class="btn" type="button" @click="resetFilters">Reset</button>
                </div> -->
            </div>
        </div>
    </div>
   
</template>

<script>
import axios from 'axios'
export default{
    name: 'searchtextblock',
    data() {
        return {
            filter: null,
            timer: null,
        }
    },
    watch: {
        filter: function() {
            // console.log("A change was made: ", this.filter)
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            this.timer = setTimeout(() => {
                this.emitChange(this.filter);
            }, 1000)
        }
    },
    methods: {
        emitChange(filter) {
            this.$emit('filterChange', filter)
        }
    }
}
</script>

<style lang="sass">
    button
        transition: background .25s ease-in-out;
    button.selected
        // background: $color-pink
        // background: #ef6537
        // background: #efef37
        // color: $color-primary
        // ::hover
        //     background: $color-tertiary
    button.selected:hover
        // background: $color-pink
        // background: #ef6537
        // background: #efef37
        
</style>

<style scoped>
    .dropdown-options {
        background-color: #585858;
        color: #ffffff;
        /* overflow: scroll; */
        padding: 2rem;
        transition: all .15s ease-in-out;
        top: -10px;
        left: 9px;
        transform: translateY(-100%);
        z-index: 1;
        position: absolute;
        width: 100%;
        min-width: 30rem;
        text-align: left;
        padding: 2rem 2rem 7rem 2rem !important;
        /* opacity: 0; */
    }

    .search-filter > .full-width > .row{
        max-width: 112rem;
        padding: 0;
        margin: 0 auto;
    }

    .search-filter .done-button{
        position: absolute;
        bottom: 2rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 80%;
    }

    .dropdown-open {
        /* max-height: 500px; */
        /* border: white thin solid; */
        opacity: 1;
        transform: translateY(10px);
    }

    .double-row{
        min-width: 55rem;
    }

    .search-filter{
        /* padding: 1.5rem 0; */
    }

    .search-filter button{
        width: 80%;
        text-align: center;
        background-color: transparent;
        height: 4.5rem;
        padding: 0;
        /* margin: 0; */
        border-radius: 1rem;
        background: #ffffff;
        /* background-color: #e4e4e4; */
        border: 0.25rem solid #333333;
        /* padding: 1rem; */
        color: #333;
    }

    .search-filter .top{
        /* background: #4a4949;
        background-color: #abdf2f;
        background-color: #e4e4e4; */
        /* background: #333; */
        position: relative;
        z-index: 2;
    }

    .search-filter button{
        width: 100%;
    }

    .search-filter .top{
        padding: 2rem 1rem;
    }

    .search-filter button{
        margin: 0;
    }
</style>